import $ from 'jquery';

export default function initTimeline() {
  $('.js-timeline').each(function () {
    const elem = $(this);
    elem.find('.js-content').each(function () {
      const wrap = $(this);
      wrap.on('click', 'read-more', function (e) {
        console.log('click'); //eslint-disable-line
        e.preventDefault();
        $(this).hide();
        wrap.find('.more').slideDown();
      });
    });
  });
}
